var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterTable = function SvgFilterTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.5 23.89"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".filter-table_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-table_svg__acfa186b-2393-4128-893a-920903ca4ee7",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-table_svg__a677f7a8-5ce2-4575-9478-4af75c0f2390",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 9.39h-10a.73.73 0 0 1-.62-1.14l5-7.43A.73.73 0 0 1 6.9.83l5 7.43a.72.72 0 0 1-.64 1.13M1.23 14.5h10a.72.72 0 0 1 .6 1.13l-5 7.44a.74.74 0 0 1-1.22 0l-5-7.44a.73.73 0 0 1 .62-1.13",
    className: "filter-table_svg__a"
  })))));
};
export default SvgFilterTable;